<template>
  <div class="side-navbar" :style="{
    minWidth: sidebarOpen ? '250px' : '0',
    height: '100%',
    backgroundColor: '#FFFFFF',
  }">
    <div>
      {{ updateColor() }}
    </div>
    <div v-if="newSurvey === 1" class="notification-dot"></div>
    <b-button v-b-toggle.navSidebarId class="nav_toggle" @click="toggleSidebar" :style="{
      position: 'fixed',
      zIndex: '1050',
      width: sidebarOpen ? '217.5px' : 'fit-content',
    }">
      {{ this.sidebarButtonText }}
    </b-button>
    <b-sidebar id="navSidebarId" visible no-header noCloseOnRouteChange text-variant="dark" shadow>
      <!-- <div class="simulence-logo-sidebar"><img src="../../assets/Simulence_logo.png" id="logo-img"></div> -->
      <div id="sectionSeparator">
        <b-nav vertical class n="side-navbar-item" ref="navbar-item">
          <b-nav-item v-for="(tag, index) in navTags2"
                      :key="tag.name"
                      class="side-navbar-text"
                      @click="changeTag(tag, index)">
            <div class="sidebar-tag-text" :style="{
              color: (index === selected ? 'var(--theme-color)' : $store.state.sidetext),
              borderLeft: (index === selected ? `4px solid var(--theme-color)` : ''),
              paddingLeft: '12px',
              fontWeight: (index === selected ? '600' : '500')
            }">
              {{ tag.name }}
            </div>
          </b-nav-item>
        </b-nav>

        <div class="faq-txt" @click="openFAQ">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="black" class="bi bi-question-circle"
              viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
          </svg>

          <div class="px-3">
            FAQ
          </div>
        </div>

        <b-nav class="admin-item">
          <div v-if="this.login" class="account-type">
            <div class="account-wrapper">
              <div class="account-type-txt" @click="goProfile" :style="{
                color: (selected === -1 ? 'var(--theme-color)' : $store.state.sidetext),
                borderLeft: (selected === -1 ? `4px solid var(--theme-color)` : ''),
                paddingLeft: (selected === -1 ? '12px' : ''),
                fontWeight: (selected === -1 ? '600' : '500'),
                }">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" class="bi bi-person-circle" viewBox="0 0 16 16" 
                  :fill="(selected === -1 ?'var(--theme-color)' : $store.state.sidetext)"
                >
                  <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                  <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
                </svg>
                <div class="px-3">
                  Profile
                </div>
              </div>
            </div>
            <div class="settings-txt" @click="goSettings">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-gear" viewBox="0 0 16 16">
                <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"/>
                <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"/>
              </svg>
              <div class="link settings-nav" >Settings</div>
            </div>
            <div class="logout-txt" @click="handleLogout" title="Logout">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="black" class="bi bi-box-arrow-left"
                  viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                      d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"/>
                <path fill-rule="evenodd"
                      d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"/>
              </svg>
              <span class="logout-nav">Logout</span>
            </div>
          </div>
        </b-nav>

      </div>
    </b-sidebar>

    <!-- FAQ Panel Component - positioned relative to viewport -->
    <FAQPanel ref="faqPanel" />
  </div>
</template>

<script>
// NOTE: THIS IS THE NEW NAVBAR (SIDEBAR)
import UserObject from "../../Firestore/UserObject";
import FAQPanel from "./FAQ.vue";

export default {
  name: "navigator",
  components: {
    FAQPanel
  },
  props: {
    flag: {
      type: Number
    },
  },
  data() {
    return {
      sidebarButtonText: "☰",
      sidebarOpen: true,
      msg: "",
      userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1,
      userAvatar: window.localStorage.getItem("userAvatar"),
      login: window.localStorage.getItem("userType") ? true : false,
      navTags2: [],
      selected: window.localStorage.getItem("navIndex"),
      newSurvey: window.localStorage.getItem("newSurvey"),
      testerNavTags: [
        {
          name: "Dashboard",
          link: "dashboard",
        },/* {
          name: "My Projects",
          link: "test",
        },*/ {
          name: "Discover",
          link: "discover",
        }, {
          name: "Achievements",
          link: "achievements",
        }
      ],
      companyNavTags: [
        {
          name: "Dashboard",
          link: "dashboard",
        }, /*{
          name: "Projects",
          link: "test",
        }, */{
          name: "Surveys",
          link: "surveys",
        }/*, {
          name: "Calendar",
          link: "calendar",
        }*/
      ],
      adminNavTags: [
        {
          name: "Dashboard",
          link: "dashboard",
        }, {
          name: "Users",
          link: "users",
        }, {
          name: "Projects",
          link: "adminprojects",
        }, {
          name: "Templates",
          link: "templates",
        }, {
          name: "Surveys",
          link: "surveys",
        },{
          name: "Blacklist",
          link: "blacklist",
        },{
          name:" AI Moderation",
          link: "aimoderation",
        }
          /*, {
          name: "Calendar",
          link: "calendar",
        }*/
      ],
      windowWidth: window.innerWidth
    }
  },
  mounted() {
    const userType = parseInt(window.localStorage.getItem("userType"));
    if (userType === 0) {
      this.navTags2 = this.testerNavTags;
      this.checkForNewSurvey();
    } else if (userType === 1) {
      this.navTags2 = this.companyNavTags;
    } else if (userType === 2) {
      this.navTags2 = this.adminNavTags;
    }

    let found = false;
    this.navTags2.forEach((page, i) => {
      if (this.$route.path.startsWith(`/${page.link}`)) {
        this.selected = i;
        found = true;
      }
    });
    if (this.$route.path.startsWith("/userprofile")) {
      this.selected = -1;
      found = true;
    }
    if (this.$route.path.startsWith("/settings")) {
      this.selected = -2;
      found = true;
    }
    // Fallback to this only if path can't be matched
    if (!found) {
      const storedIndex = window.localStorage.getItem("navIndex");
      if (storedIndex !== null) {
        this.selected = parseInt(storedIndex);
      }
    }

    // Update fallback
    window.localStorage.setItem("navIndex", this.selected);
  },
  methods: {
    changeTag: function (tag, idx) {
      this.selected = idx
      window.localStorage.setItem("navIndex", this.selected);
      // to get UI to update first
      if (this.$route.name !== this.navTags2[idx].link) {
        setTimeout(() => {
          this.$router.push({
            name: this.navTags2[idx].link,
          });
        }, 0);
      }
    },

    toggleSidebar: function () {
      if (this.sidebarOpen) {
        this.sidebarButtonText = "☰";
      } else {
        this.sidebarButtonText = "☰";
      }
      this.sidebarOpen = !this.sidebarOpen;
    },

    goProfile: function () {
      this.selected = -1;
      if (!this.$route.path.startsWith("/userprofile")) {
        window.localStorage.setItem("navIndex", this.selected);
        window.localStorage.setItem("userProfileIndex", 0);
        setTimeout(() => {
          this.$router.push({
            name: "userprofile",
          });
        }, 0);
      }
    },
    goSettings() {
      this.selected = -2; 
      if (!this.$route.path.startsWith("/settings")) {
        window.localStorage.setItem("navIndex", this.selected);
        window.localStorage.setItem("settingsIndex", 0);
        setTimeout(() => {
          this.$router.push({
            name: "notificationsLink",
          });
        }, 0);
      }
    },

handleLogout: function () {
  // ✅ Preserve onboarding data for the current user only
  const userId = localStorage.getItem("userId");
  const preservedData = {};

  if (userId) {
    // Keep onboarding flags only for the current user
    const testerKey = `hasSeenTesterOnboardingAt_${userId}`;
    const devKey = `hasSeenDevOnboardingAt_${userId}`;

    if (localStorage.getItem(testerKey)) {
      preservedData[testerKey] = localStorage.getItem(testerKey);
    }
    if (localStorage.getItem(devKey)) {
      preservedData[devKey] = localStorage.getItem(devKey);
    }
  }

  // Execute logout process
  UserObject.logoutUser()
    .catch((e) => {
      console.warn("Logout request failed, clearing local data anyway:", e);
    })
    .finally(() => {
      // Clear all localStorage data
      localStorage.clear();

      // ✅ Restore onboarding data for this specific user
      Object.entries(preservedData).forEach(([key, value]) => {
        localStorage.setItem(key, value);
      });

      // Optional: show a short toast message (if you have a global toast system)
      // this.$toast.success("Logged out successfully");

      // Redirect to login page
      this.$router.push({ name: "login" });
    });
},
    // each time when the user goes to a different view of the website(when the navigation bar is reloaded), we check if there has been a new survey assigned to the tester,
    // and if there is a new survey, shows the notification dot
    checkForNewSurvey: async function () {
      let that = this;
      //TODO: implement checking for new surveys to show notif dot

    },
    updateColor: function () {
      const r = document.querySelector(':root');
      r.style.setProperty('--NAVTHEME', this.$store.state.navtheme);
      r.style.setProperty('--NAVCTN', this.$store.state.navctn);
      r.style.setProperty('--NAVEFFECT', this.$store.state.naveffect);
      r.style.setProperty('--TRIANGLE', this.$store.state.triangle);
      r.style.setProperty('--ACCOUNT', this.$store.state.account);
      r.style.setProperty('--LOGOUT', this.$store.state.account);

      // unified orange theme
      r.style.setProperty('--theme-color', '#FF7222');            
      r.style.setProperty('--theme-color-light', 'rgba(255,114,34,0.15)');
      r.style.setProperty('--theme-color-medium','rgba(255,114,34,0.10)');
    },

    openFAQ: function () {
      // Open the FAQ panel using the correct method
      this.$refs.faqPanel.openFAQ();
    },
  }
}
</script>

<style scoped>

.sidebar-tag-text {
  margin-left: -0.1rem;
  font-size: 25px;
  font-weight: 500;
  /*padding-left: 1rem;*/
  position: relative;
  transition: color 0.2s;
}


.side-navbar-text {
  margin-left: 5%;
  margin-top: 5%;
  white-space: nowrap;
  padding-left: 5%;
  border-radius: 15px;
  padding-right: 5%;
  margin-right: 25%;
  color: black;
  text-decoration: none;
}

.sidebar-tag-text::before {
  content: "";
  position: absolute;
  left: -0.26rem;
  top: 0;
  width: 4px;
  height: 100%;
  background: var(--theme-color, #FF7222);
  border-radius: 2px;
  opacity: 0;
  transform: scaleY(0.5);
  transition: opacity 0.2s, transform 0.2s;
  z-index: 1;
}

.side-navbar-text:hover .sidebar-tag-text::before,
.sidebar-tag-text.selected::before {
  opacity: 1;
  transform: scaleY(1);
}

.admin-item {
  width: 100%;
  margin-left: 0;
  margin-top: 0;
  font-size: 24px;
}

@media only screen and (max-height: 600px) {
  .side-navbar-item {
    margin-top: 10%;
  }

  .side-navbar-text {
    margin-top: 8%;
  }

  .admin-item {
    margin-top: 20%;
    position: relative;
    font-size: 18px;
  }
}

.account-type {
  margin-bottom: 0;
  font-size: 26px;
  margin-left: 0;
}

.account-wrapper{
  display: flex;
  flex-direction: row;
  align-items: center;
}

.admin-item:hover {
  color: #424241 !important;
  cursor: pointer;
}

.bi-person-circle{
  display: flex;
  align-self: center;
}


.account-type-txt {
  cursor: pointer;
  margin-left: 2.5rem;
  margin-top: 21px;
  margin-bottom: 0;
  display: flex;
  font-size: 25px;
  font-weight: 600;
}

.settings-txt{
  cursor: pointer;
  margin-left: 2.5rem;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  font-size: 25px;
  font-weight: 600;
}
.settings-nav{
  align-self: center;
  margin-left: 1rem;
  text-decoration: none;
  color: inherit;
  font-size: 25px;
  font-weight: 500;
}

.logout-txt {
  cursor: pointer;
  display: flex;
  margin-left: 2.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0;
  font-size: 25px;
  font-weight: 600;
}

.logout-nav{
  align-self: center;
  margin-left: 1rem;
  text-decoration: none;
  color: inherit;
  font-size: 25px;
  font-weight: 500;
}

.sidebar-tag-text:hover, .account-type-txt:hover, .logout-txt:hover,.settings-txt:hover {
  opacity: 0.7 !important;
  cursor: pointer;
}

.side-navbar-text > a {
  display: flex;
  align-items: center;
}

.px-3 {
  margin-top: -3px;
}

#sectionSeparator {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  padding-top: 3.5rem;
  overflow-x: hidden;
}

#sectionSeparator > ul:last-child{
  margin-top: auto;
}

>>> #navSidebarId {
  width: 250px !important;
  background-color: #FFFFFF !important;
}

.nav_toggle {
    position: absolute;
    margin-top: 1rem;
    margin-left: 1rem;
    z-index: 1050;
    width: 240px;
    color: #000;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    background-color: rgba(255, 255, 255, 0.95);
    border: 2px solid var(--theme-color, #FF7222);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1), 0 0 0 1px var(--theme-color, #FF7222);
}

.nav_toggle:hover {
    background-color: rgba(255, 255, 255, 1);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px var(--theme-color-light, rgba(255,114,34,0.3)), 0 0 0 2px var(--theme-color, #FF7222);
    border-color: var(--theme-color, #FF7222);
}

.faq-txt {
  cursor: pointer;
  display: flex;
  margin-left: 2.5rem;
  margin-top: 29px;
  margin-bottom: 0;
  font-size: 25px;
  font-weight: 600;
}

</style>


// WEBPACK FOOTER //
// src/components/layout/NavBarNew.vue